const ReminderType = {
  mot: 'MOT',
  tax: 'Tax',
  service: 'Service',
  insurance: 'Insurance',
};
export default ReminderType;
